import { IUser } from '../../interfaces/models/user'

const MOBILE_ONBOARDING_COMPLETE_KEY = 'ld_mobile_onboarding_complete'

export const markMobileOnboardingComplete = (userId?: string) => {
    if (!userId) return
    try {
        localStorage.setItem(MOBILE_ONBOARDING_COMPLETE_KEY, userId)
    } catch {
        /* ignore */
    }
}

export const hasCompletedMobileOnboarding = (userId?: string): boolean => {
    if (!userId) return false
    try {
        return localStorage.getItem(MOBILE_ONBOARDING_COMPLETE_KEY) === userId
    } catch {
        return false
    }
}

/** Persisted on backend (preferences) + localStorage fallback for same session. */
export const hasFinishedMobileOnboarding = (user?: IUser | null, userId?: string): boolean => {
    const id = userId ?? user?._id
    if (user?.preferences?.mobileOnboardingFinished) return true
    return hasCompletedMobileOnboarding(id)
}
